// API client for the Email Delivery Log (staff triage of invitation/password
// email delivery). Backend: GET /email-events in the dashone monorepo
// (apps/api), a Dashmote-staff-only proxy to the Mailgun Logs API. The Mailgun
// key stays server-side; this client only talks to our endpoint.
import { getApiUrl } from "../utils/envConfig";
import { makeAuthenticatedRequest } from "./authApi";

// Returns { items: EmailEvent[], count, duration, truncated }.
// `duration` is bounded by Mailgun's 5-day log retention — one of 1d / 3d / 5d.
export const fetchEmailEvents = async ({ duration = "5d" } = {}) => {
  try {
    const qs = `?duration=${encodeURIComponent(duration)}`;
    return await makeAuthenticatedRequest(`${getApiUrl()}/email-events${qs}`);
  } catch (error) {
    throw new Error("Failed fetching email events: " + error.message);
  }
};
